import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pc_login = _resolveComponent("pc-login")
  const _component_mobile_login = _resolveComponent("mobile-login")

  return (_ctx.device.display !== 1)
    ? (_openBlock(), _createBlock(_component_pc_login, { key: 0 }))
    : (_openBlock(), _createBlock(_component_mobile_login, { key: 1 }))
}